import { render, staticRenderFns } from "./PageHeaderUI.vue?vue&type=template&id=41b23c38&scoped=true"
import script from "./PageHeaderUI.vue?vue&type=script&lang=js"
export * from "./PageHeaderUI.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderUI.vue?vue&type=style&index=0&id=41b23c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b23c38",
  null
  
)

export default component.exports